<i class="fa-light fa-hands-holding-heart gradient"></i>
<div class="content">
  <app-button
    dataLabel="tell-us-your-support-needs"
    [buttonOptions]="{
      variant: 'link',
      isLink: true,
      url: myPreferencesPageLink,
    }"
  >
    <span><i class="fa-light fa-hands-holding-heart gradient mr-8"></i>Tell us your support needs </span>
    <i class="fa-light fa-arrow-right ml-8"></i>
  </app-button>

  <p class="body mt-8">
    Let us know what help you need. When you use our services, we’ll support you as best we can.  
  </p>
</div>
